import { css } from "react-emotion";

const colors = {
  // style guide colors:
  primary: "#20b4b2",
  primarySecond: "#21D2D0",
  grayDark: "#3e3e3e",
  gray: "#a2a2a2",
  grayC: "#cacaca",
  grayF: "#f2f2f2",

  selected: "#149e9c",
  hover: "#41d2d0",
  success: "#38b584",
  danger: "#ff043f",
  primaryLight: "#BDE8E9",
  primaryInverse: "#ffffff",
  blackA: "#000000",
  redA: "#FF4C58",

  // others

  blue: "#d2f0f0",

  black: "#161616",
  grayDarkA: "#333333",
  grayD: "#dbdbdb",
  grayE: "#ececec",
  grayG: "#4d4d4d",
  white: "#fff",

  grayOO: "#b5b3b3",
  grayOA: "#e6e6e6",

  red0: "#f53a47",

  staticElement: "#7b7b7c",
  greyBackground: "#f4f4f4",
  grayBackground2: "#f7f7f7",

  blockBackground: "hsla(179, 70%, 42%, 0.2)",
  blockFont: "hsla( 0, 0%, 100%, 1 )",
  blockBorder: "hsla( 0, 0%, 10%, 1 )",
  border: "hsla( 0, 0%, 70%, 1 )",
  fontInverse: "hsla(360, 100%, 100%, 1)",
};

const bg = {
  colors: Object.keys(colors).reduce(
    (acc, key) => ({
      ...acc,
      [key]: css`
        background-color: ${colors[key]};
      `,
    }),
    {}
  ),
};

const media = {
  xsMax: "@media (max-width: 767px)",
  smMin: "@media (min-width: 768px)",
  smMax: "@media (max-width: 992px)",
  mdMin: "@media (min-width: 1200px)",
  mdMax: "@media (max-width: 1199px)",
  sm: "@media (min-width: 768px) and (max-width: 991px)",

  iphone8Min: "@media (min-width : 375px) and (max-width : 767px)",
};

const fonts = {
  // style guide font sizes
  h1: css`
    font-size: 3em;
    ${media.xsMax} {
      font-size: 2em;
    }
  `,
  h2: css`
    font-size: 2rem;
    ${media.xsMax} {
      font-size: 1.5rem;
    }
  `,
  h3: css`
    font-size: 1.5rem;
    ${media.xsMax} {
      font-size: 1.2rem;
    }
  `,
  regular: css`
    font-size: 1em;
    ${media.xsMax} {
      font-size: 1em;
    }
  `,

  // others
  xs: css`
    font-size: 11px;
  `,
  s: css`
    font-size: 12px;
  `,
  sm: css`
    font-size: 14px;
  `,
  m: css`
    font-size: 16px;
  `,
  l: css`
    font-size: 18px;
  `,
  xl: css`
    font-size: 24px;

    ${media.xsMax} {
      font-size: 18px;
    }
  `,
  xxl: css`
    font-size: 34px;

    ${media.xsMax} {
      font-size: 18px;
    }
  `,
  xxxl: css`
    font-size: 45px;

    ${media.xsMax} {
      font-size: 24px;
    }
  `,
  xxxxl: css`
    font-size: 64px;

    ${media.xsMax} {
      font-size: 34px;
    }
  `,
  i: css`
    font-style: italic;
  `,
  roman: css`
    font-family: Avenir-Roman, Helvetica;
    font-weight: 300;
  `,
  normal: css`
    font-family: Avenir-Light, Helvetica;
    font-weight: 300;
  `,
  bold: css`
    font-family: Avenir-Medium, Helvetica;
    font-weight: 500;
  `,
  boldHeavy: css`
    font-family: Avenir-Medium, Helvetica;
    font-weight: 900;
  `,
  upper: css`
    text-transform: uppercase;
  `,
  colors: Object.keys(colors).reduce(
    (acc, key) => ({
      ...acc,
      [key]: css`
        color: ${colors[key]};
      `,
    }),
    {}
  ),

  //  -size-m": "18px",
  // -size-l": "18px",
  // -size-large-mob": "25px",
  // -size-medium": "30px",
  // -size-large": "50px",
  // -family": "Avenir-Light",
  // -family-medium": "Avenir-Medium",
  // -bold": "Avenir-Medium",
  // -family-roman": "Avenir-Roman",
};

const headers = {
  m: css`
    font-size: 28px;
    margin-top: 0px;
    margin-bottom: 10px;
  `,
  l: css`
    text-align: center;
    ${fonts.xxl};
    margin-top: 0px;
    margin-bottom: 40px;
  `,

  underline: css`
    content: "";

    border-bottom: 1px solid ${colors.primary};
    display: inline-block;
    width: 100%;
  `,
};

const icons = {
  arrowUpWithCircle: css`
    display: inline-block;
    width: 40px;
    height: 40px;
    background: url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%2225%22%20height%3D%2225%22%3E%0A%20%20%3Cg%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20transform%3D%22translate%281%201%29%22%3E%0A%20%20%20%20%3Cpath%20fill%3D%22currentColor%22%20d%3D%22M17%2013.144c0%20.09-.037.169-.11.237l-.551.516a.36.36%200%200%201-.507%200L11.5%209.845l-4.332%204.052a.36.36%200%200%201-.507%200l-.55-.516A.316.316%200%200%201%206%2013.144c0-.089.037-.168.11-.237l5.136-4.804a.36.36%200%200%201%20.508%200l5.136%204.804c.073.069.11.148.11.237z%22/%3E%0A%20%20%20%20%3Ccircle%20cx%3D%2211.5%22%20cy%3D%2211.5%22%20r%3D%2211.5%22%20stroke%3D%22currentColor%22%20stroke-width%3D%221.3%22/%3E%0A%20%20%3C/g%3E%0A%3C/svg%3E);
  `,
};

const space = {
  m: `20px`,
  l: `30px`,
  xl: `40px`,
  xxl: `50px`,
};

const limits = {
  maxWidth: "767px",
  minWidth: "768px",
  smMax: "992px",
  maxSWidth: "1199px",
  minSWidth: "1200px",
};

const paddings = {
  section: css`
    padding: 30px 0 50px;
  `,
  mhv: css`
    padding: 20px;
  `,
  ctaPaddings: css`
    padding: 12px 20px;
    @media (max-width: ${limits.maxWidth}) {
      padding: 12px;
    }
  `,
  mv: css`
    padding-top: 20px;
    padding-bottom: 20px;
  `,
  lv: css`
    padding-top: 30px;
    padding-bottom: 30px;
  `,
  xlv: css`
    /*padding-top: 40px;
    padding-bottom: 40px;*/
    padding: 4.5rem 0;
  `,
  xxlv: css`
    padding-top: 50px;
    padding-bottom: 50px;
  `,
  xxxlv: css`
    padding-top: 115px;
    padding-bottom: 115px;

    ${media.xsMax} {
      padding-top: 50px;
      padding-bottom: 50px;
    }
  `,
};

const margins = {
  mhv: css`
    margin: 20px;
  `,

  mv: css`
    margin-top: 20px;
    margin-bottom: 20px;
  `,
  lv: css`
    margin-top: 30px;
    margin-bottom: 30px;
  `,
  xlv: css`
    margin-top: 40px;
    margin-bottom: 40px;
  `,
  xxlv: css`
    margin-top: 50px;
    margin-bottom: 50px;
  `,
  xxxlv: css`
    margin-top: 115px;
    margin-bottom: 115px;

    ${media.xsMax} {
      margin-top: 50px;
      margin-bottom: 50px;
    }
  `,
};

const misc = {
  containerNoMobile: `container ${css`
    ${media.xsMax} {
      padding-left: 0px;
      padding-right: 0px;
    }
  `}`,
  centerv: css`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  `,
  centerh: css`
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  `,
  centerhv: css`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  `,
};

function button({
  color,
  hoverColor,
  bgColor,
  hoverBgColor,
  borderColor,
  hoverBorderColor,
  activeColor,
  hoverTouchColor,
}) {
  return css`
    ${fonts.m};
    text-align: center;
    padding: 3px 12px;
    min-width: 150px;
    border-radius: 5px;
    line-height: 38px;
    text-transform: uppercase;
    text-decoration: none;
    display: inline-block;
    outline: none;
    cursor: pointer;
    background-color: ${bgColor};
    border: 1px solid ${borderColor};
    color: ${color};

    &.small {
      padding: 6px 12px;
      font-size: 14px;
      line-height: normal; /* IE 11 fix */
      line-height: initial;
      min-width: auto;
    }

    &.default-2 {
      ${fonts.m};
      padding: 8px 12px;
      line-height: normal; /* IE 11 fix */
      line-height: initial;
    }

    &.large {
      ${fonts.l};
      padding: 10px 24px;
      line-height: normal; /* IE 11 fix */
      line-height: initial;
    }

    &.xlarge {
      ${fonts.l};
      padding: 14px 24px;
      line-height: normal; /* IE 11 fix */
      line-height: initial;
    }

    &.wide {
      width: 100%;
      max-width: 200px;
      padding-left: 50px;
      padding-right: 50px;
    }

    &.transform-none {
      text-transform: none;
    }

    &.bold-heavy {
      ${fonts.boldHeavy};
    }

    &.no-wrap {
      white-space: nowrap;
    }

    &.thin {
      line-height: 24px;
      height: 24px;
      padding: 0px 12px;
      font-size: 12px;
    }

    &.no-min {
      min-width: auto;
    }

    html[data-touch="no-touch"] & {
      :hover {
        background-color: ${hoverBgColor};
        border: 1px solid ${hoverBorderColor || hoverBgColor};
        color: ${hoverColor || color} !important;
        text-decoration: none;
      }
    }

    &:visited,
    &:active,
    &:focus {
      color: ${activeColor || color} !important;
      text-decoration: none;
    }

    &[disabled],
    html[data-touch="no-touch"] & [disabled]:hover {
      background-color: #ccc !important;
      border-color: #ccc !important;
      cursor: not-allowed;
    }

    html[data-touch="touch"] & {
      :hover,
      :focus,
      :visited,
      :active {
        color: ${hoverTouchColor || hoverColor};
        text-decoration: none;
      }
    }
  `;
}

// color: ${colors.primaryInverse};
// ${fonts.normal};
// ${fonts.h3};
// ${paddings.ctaPaddings} border-radius: 5px;

// white-space: nowrap;

// text-transform: uppercase;
// outline: none;
// background-color: ${colors.primary};
// border: 1px solid ${colors.primary};

// html[data-touch="no-touch"] & {
//   :hover {
//     background-color: ${colors.hover};
//     border: 1px solid ${colors.hover};
//     text-decoration: none;
//     color: ${colors.primaryInverse};
//   }
// }

const buttons = {
  /* from style guide */
  cta: props => css`
    ${button({
      color: props.theme.colors.primaryInverse,
      hoverColor: props.theme.colors.white,
      bgColor: props.theme.colors.primary,
      hoverBgColor: props.theme.colors.hover,
      borderColor: props.theme.colors.primary,
    })};
  `,

  primary: props => css`
    ${button({
      color: props.theme.colors.primaryInverse,
      hoverColor: props.theme.colors.white,
      bgColor: props.theme.colors.primary,
      hoverBgColor: props.theme.colors.hover,
      borderColor: props.theme.colors.primary,
    })};
  `,
  text: props => css`
    cursor: pointer;
    text-decoration: underline;
    ${button({
      color: props.theme.colors.primaryInverse,
      hovercolor: props.theme.colors.white,
      bgcolor: props.theme.colors.primary,
      hoverbgcolor: props.theme.colors.hover,
      bordercolor: props.theme.colors.primary,
    })};
  `,
  cancel: props => css`
    ${button({
      color: props.theme.colors.danger,
      bgColor: props.theme.colors.white,
      hoverBgColor: props.theme.colors.white,
      borderColor: props.theme.colors.danger,
    })};
  `,
  light: props => css`
    ${button({
      color: props.theme.colors.primary,
      hoverColor: props.theme.colors.hover,
      bgColor: props.theme.colors.primaryInverse,
      borderColor: props.theme.colors.primary,
      hoverBgColor: props.theme.colors.primaryInverse,
      hoverBorderColor: props.theme.colors.hover,
    })};

    font-weight: normal;
  `,

  white: props => css`
    ${button({
      color: props.theme.colors.primary,
      hoverColor: props.theme.colors.hover,
      bgColor: props.theme.colors.primaryInverse,
      borderColor: props.theme.colors.primary,
      hoverBgColor: props.theme.colors.primaryInverse,
      hoverBorderColor: props.theme.colors.hover,
    })};
  `,

  gray: props => css`
    ${button({
      color: props.theme.colors.primaryInverse,
      hoverColor: props.theme.colors.gray,
      bgColor: props.theme.colors.grayDark,
      borderColor: props.theme.colors.primaryInverse,
      hoverBgColor: props.theme.colors.grayDark,
      hoverBorderColor: props.theme.colors.gray,
    })};
  `,

  gray2: props => css`
    ${button({
      color: props.theme.colors.primaryInverse,
      hoverColor: props.theme.colors.gray,
      bgColor: props.theme.colors.grayC,
      borderColor: props.theme.colors.primaryInverse,
      hoverBgColor: props.theme.colors.grayC,
      hoverBorderColor: props.theme.colors.gray,
    })};
  `,

  grayLight: props => css`
    ${button({
      color: props.theme.colors.grayDark,
      hoverColor: props.theme.colors.primaryInverse,
      bgColor: props.theme.colors.primaryInverse,
      borderColor: props.theme.colors.grayDark,
      hoverBgColor: props.theme.colors.primary,
      hoverBorderColor: props.theme.colors.primary,
      activeColor: props.theme.colors.grayDark,
      hoverTouchColor: props.theme.colors.grayDark,
    })};
  `,

  gray3: props => css`
    ${button({
      color: props.theme.colors.gray,
      hoverColor: props.theme.colors.hover,
      bgColor: props.theme.colors.grayF,
      borderColor: props.theme.colors.grayF,
      hoverBgColor: props.theme.colors.primaryInverse,
      hoverBorderColor: props.theme.colors.hover,
    })};
  `,

  gray4: props => css`
    ${button({
      color: props.theme.colors.grayOO,
      hoverColor: props.theme.colors.primaryInverse,
      bgColor: props.theme.colors.primaryInverse,
      borderColor: props.theme.colors.grayOO,
      hoverBgColor: props.theme.colors.primary,
      hoverBorderColor: props.theme.colors.primary,
    })};
  `,

  disabled: props => css`
    opacity: 0.5;
    ${button({
      color: props.theme.colors.primaryInverse,
      hoverColor: props.theme.colors.white,
      bgColor: props.theme.colors.primary,
      hoverBgColor: props.theme.colors.hover,
      borderColor: props.theme.colors.primary,
    })};
  `,
  // padding: var(--m-padding);

  transparent: props => css`
    ${button({
      color: props.theme.colors.primaryInverse,
      hoverColor: props.theme.colors.primaryInverse,
      bgColor: "transparent",
      hoverBgColor: props.theme.colors.hover,
      borderColor: props.theme.colors.primaryInverse,
    })};
  `,
  blank: props => css`
    ${button({
      ...props,
    })};
  `,

  transparentLight: css`
    border: 1px solid;
    border-radius: 5px;
    outline: none;
    background-color: transparent;
    text-transform: uppercase;
    padding: 10px;
    font-weight: normal;
    display: inline-block;
    cursor: pointer;

    html[data-touch="no-touch"] & {
      :hover {
        text-decoration: none;
        opacity: 0.8;
      }
    }
  `,
};

const defaults = {
  headerUnderline: css`
    border-bottom: 1px solid ${colors.primary};
  `,
  headerLine: css`
    overflow: hidden;

    &:after {
      content: "";
      display: inline-block;
      vertical-align: middle;
      margin-right: -100%;
      margin-left: 10px;
      margin-top: -3px;
      width: 100%;
      height: 1px;
      border: solid 1px ${colors.primary};
    }
  `,
  bannerHeaders: css`
    ${fonts.normal};
    font-size: 26px;
    text-align: center;
    @media (max-width: ${limits.maxWidth}) {
      font-size: 22px;
    }
  `,
  bannerHeaderBold: css`
    ${fonts.boldHeavy};
  `,
  bannerHeaderTitle: css`
    color: ${colors.white};
    padding-top: 20px;
    @media (max-width: ${limits.maxWidth}) {
      font-size: 22px;
    }
  `,
  bannerHeaderTitleRightMobile: css`
    @media (max-width: ${limits.maxWidth}) {
      text-align: right !important;
      width: 200px;
      float: right;
    }
  `,
  bannerHeaderSubTitle: css`
    ${fonts.normal};
    color: ${colors.white};
    font-size: 16px;
    text-align: center;
    @media (max-width: ${limits.maxWidth}) {
      font-size: 16px;
      margin-right: 15px;
      margin-left: 15px;
    }
  `,
  sectionHeader: css`
    padding-top: 50px;
    line-height: 1.25;
    color: #333333;
    ${fonts.bold};
    font-size: 36px;
    text-align: center;
    margin-left: 30px;
    margin-right: 30px;
    @media (max-width: ${limits.maxWidth}) {
      font-size: 22px;
      margin-bottom: 15px;
      margin-left: 15px;
      margin-right: 15px;
    }
  `,
  sectionSubTitle: css`
    ${fonts.normal};
    /* ${fonts.m}; */
    text-align: center;
    color: #333333;
    margin-top: 10px;
  `,
};

// const derived = {
//   "--color-link": basic["--color-primary"],
//   "--color-link-inverse": "white",
//   "--color-link-inverse-hover": "white",

//   "--color-font": basic["--color-black"],
//   "--color-disabled": basic["--color-light-gray"],
// };

export default {
  bg,
  headers,
  fonts,
  paddings,
  margins,
  colors,
  buttons,
  media,
  icons,
  space,
  misc,
  defaults,
  limits,
};
